export default "__VITE_ASSET__DnK3N2p4__"